import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { prop, pick } from 'ramda';
import { storageService } from 'js/services/storage.service';
import { WebSocketService } from 'js/services/webSocket.service';
import { useLiveGamesSelector, useAppSelector } from 'js/store/hooks';

import * as actions from '../store/actions';
import { TLiveGamesRequestMessage, TLiveGamesResponseMessage } from '../types';

export const useLiveGamesCreateWS = () => {
    const dispatch = useDispatch();
    const liveEndpointUrl = useAppSelector(prop('liveEndpointUrl'));
    const { socket, isNeedToStart } = useLiveGamesSelector(pick(['socket', 'isNeedToStart']));

    useEffect(() => {
        if (!socket && isNeedToStart) {
            const localLiveEndpointUrl = storageService.local.getItem('liveEndpointUrl');

            dispatch(actions.setSocket(
                new WebSocketService<
                    TLiveGamesRequestMessage,
                    TLiveGamesResponseMessage
                >({ apiURL: localLiveEndpointUrl || liveEndpointUrl })
            ));
        }
    }, [socket, liveEndpointUrl, dispatch, isNeedToStart]);
};
